import React from 'react';
import { Tooltip } from 'antd';

interface Props {
  content: JSX.Element;
  height?: number;
  icon?: string | JSX.Element;
  action?: JSX.Element;
}

/** Выстраивает в линию контент, иконку и action */
export function LineContainer(props: Props) {
  const height = props.height || 50;
  const marginTop = Math.min(height / 4, 15);
  const marginLeft = Math.min(height / 4, 15);

  return (
    <div style={{ ...lineContainerStyle, height }}>
      <div style={{ ...inlineContainer, marginTop }}>
        <span style={{ marginLeft }}>{props.content}</span>
      </div>
      {props.action && (
        <span style={{ ...actionStyle, marginTop }}>{props.action}</span>
      )}
    </div>
  );
}

/**
 * Образает текст, если он больше максимальной длины.
 * Добавляет Tooltip с полным текстом.
 */
export function Content(props: {
  content: string;
  maxLength?: number;
  style?: React.CSSProperties;
}) {
  const maxLength = props.maxLength || 40;
  let content = props.content;
  if (content.length > maxLength) {
    content = `${content.substr(0, maxLength)}...`;
  }

  return (
    <Tooltip trigger="hover" overlay={props.content}>
      <span style={props.style}>{content}</span>
    </Tooltip>
  );
}

export const inlineContainer: React.CSSProperties = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'start',
};

export const lineContainerStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  width: '100%',
};

export const actionStyle: React.CSSProperties = {
  marginRight: 15,
  cursor: 'pointer',
};

export const TitleTextStyle: React.CSSProperties = {
  userSelect: 'none',
  fontFamily: 'Golos UI',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: 14,
  color: '#34373E',
};

export const ContentTextStyle: React.CSSProperties = {
  fontFamily: 'Golos UI',
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: 12,
};
